import { render, staticRenderFns } from "./MoneyRecord.vue?vue&type=template&id=4851db8a&scoped=true&"
import script from "./MoneyRecord.vue?vue&type=script&lang=js&"
export * from "./MoneyRecord.vue?vue&type=script&lang=js&"
import style0 from "./MoneyRecord.vue?vue&type=style&index=0&id=4851db8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4851db8a",
  null
  
)

export default component.exports